// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chart-line.js';

import { paths } from '../generated/chart-line';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chart-line', Original, paths);
